import { render, staticRenderFns } from "./View4.vue?vue&type=template&id=02207656"
import script from "./View4.vue?vue&type=script&lang=js"
export * from "./View4.vue?vue&type=script&lang=js"
import style0 from "./View4.vue?vue&type=style&index=0&id=02207656&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports